/* istanbul ignore file */
export var DeinitMode;
(function (DeinitMode) {
    DeinitMode["Soft"] = "Soft";
    DeinitMode["Hard"] = "Hard";
})(DeinitMode || (DeinitMode = {}));
